import axiosInstance from "axiosInstance";
import React, { useState } from "react";
import { toast } from "react-toastify";

function KrishiJotnoHero() {
  const [formData, setFormData] = useState({
    farmerName: "",
    mobileNumber: "",
    address: "",
    voterId: "",
    cropMeasurement: "", // Added missing state variable
    cropName: "",
    plantationDeadline: "",
    cropQuantityForSale: "",
    salesTimeline: "",
    totalCropValue: "", // Added missing state variable
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    try {
      const response = await axiosInstance.post("/api/krishijotno/create-krishijotno", formData);
      toast.success("Successfully submitted form");
      setFormData({
        farmerName: "",
        mobileNumber: "",
        address: "",
        voterId: "",
        cropMeasurement: "",
        cropName: "",
        plantationDeadline: "",
        cropQuantityForSale: "",
        salesTimeline: "",
        totalCropValue: "",
      });
    } catch (error) {
      console.error(error);
      if (error.response?.data?.message) {
        toast.error(error.response?.data?.message);
      } else {
        toast.error("Failed to submit form");
      }
    }
  };

  return (
    <>
      <section className="krishijotno-hero">
        <div className="container">
          <div className="container-jotno">
            <form onSubmit={handleSubmit}>
              <div className="wrap-jonto">
                <div className="wrap-input">
                  <input
                    type="text"
                    name="farmerName"
                    placeholder="কৃষকের নাম"
                    className="input-field"
                    value={formData.farmerName}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="mobileNumber"
                    placeholder="কৃষকের মোবাইল নাম্বার"
                    className="input-field"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="address"
                    placeholder="ঠিকানা"
                    className="input-field"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="voterId"
                    placeholder="ভোটার আইডি নাম্বার"
                    className="input-field"
                    value={formData.voterId}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="cropMeasurement"
                    placeholder="উৎপাদিত ফসলের জমির পরিমাপ"
                    className="input-field"
                    value={formData.cropMeasurement}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="cropName"
                    placeholder="উৎপাদিত ফসলের নাম"
                    className="input-field"
                    value={formData.cropName}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="plantationDeadline"
                    placeholder="বীজ বপন থেকে ফসল ঘরে তোলার মেয়াদকাল"
                    className="input-field"
                    value={formData.plantationDeadline}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="salesTimeline"
                    placeholder="উৎপাদিত ফসল বিক্রির সময়সীমা"
                    className="input-field"
                    value={formData.salesTimeline}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="cropQuantityForSale"
                    placeholder="উৎপাদিত ফসল বিক্রির পরিমাণ"
                    className="input-field"
                    value={formData.cropQuantityForSale}
                    onChange={handleChange}
                  />
                </div>
                <div className="wrap-input">
                  <input
                    type="text"
                    name="totalCropValue"
                    placeholder="উৎপাদিত ফসলের সর্বমোট মূল্য নির্ধারণ"
                    className="input-field"
                    value={formData.totalCropValue}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="wrap-submit">
                <button type="submit" className="submit-krishijonto">
                  সাবমিট
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default KrishiJotnoHero;
